<script>
import DialogLayout from "@layouts/dialog.layout.vue";
import DatePicker from "@components/DatePicker.vue";
import { mapMutations } from "vuex";

export default {
  name: "EventDialogComponent",
  components: {
    DialogLayout,
    DatePicker,
  },
  props: {
    disabled: { type: Boolean, default: undefined },
  },
  data() {
    return {
      dialog: false,
      name: null,
      start: null,
      end: null,
    };
  },
  methods: {
    ...mapMutations({
      logMessage: "ui/log",
      logError: "ui/error",
    }),
    async submit() {
      try {
        await this.axios.post("/calendar/event", {
          name: this.name,
          start: new Date(this.start),
          end: new Date(this.end),
          color: "warning",
          icon: "mdi-calendar-star",
        });
        this.logMessage("Ereignis wurde erstellt");
        this.$emit("update");
        this.close();
      } catch (error) {
        console.error(error);
        this.logError("Es ist ein Fehler aufgetreten");
      }
    },
    close() {
      this.dialog = false;
      this.name = null;
      this.start = null;
      this.end = null;
      this.$emit("close");
    },
  },
};
</script>

<template>
  <DialogLayout
    v-model="dialog"
    title="Eintrag erstellen"
    width="450"
    v-bind="$attrs"
  >
    <template #activator="{ on, attrs }">
      <slot name="activator" :on="on" :attrs="attrs" />
    </template>
    <template #default>
      <v-text-field v-model="name" label="Name" />
      <DatePicker v-model="start" label="Start" />
      <DatePicker v-model="end" label="Ende" />
    </template>
    <template #action>
      <v-btn color="error" text @click="close">Abbrechen</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="submit">Speichern</v-btn>
    </template>
  </DialogLayout>
</template>
